import { createFileRoute } from "@tanstack/react-router";

import { graphql } from "@repo/graphql-types/gql";
import Left from "@repo/icons/default/Left";

import { AsyncDataWrapper } from "@/components/ui/async-data-wrapper";
import {
  HeaderButton,
  HeaderRoot,
  HeaderTitle,
} from "@/components/ui/layout/header/header";
import { Page } from "@/components/ui/layout/page/page";
import { ProfessionalDataContactInformationForm } from "@/components/profile/professional-data/professional-data-contact-information-form";
import { useGraphQL } from "@/hooks/use-graphql";

import type { JSX } from "react";

const EditProfessionalDataContactInformationPageQuery = graphql(/* GraphQL */ `
  query EditProfessionalDataContactInformationPageQuery {
    usuarios {
      ...ProfessionalDataContactInformationFormFragment
    }
  }
`);

const EditProfessionalDataContactInformationPage = (): JSX.Element => {
  const queryResult = useGraphQL(EditProfessionalDataContactInformationPageQuery, {});
  const { data } = queryResult;
  return (
    <>
      <HeaderRoot>
        <HeaderButton icon={Left} align="start" />
        <HeaderTitle title="Dados Profissionais" align="center" />
      </HeaderRoot>
      <Page className="px-6 py-8">
        <AsyncDataWrapper {...queryResult}>
          {data?.usuarios ? (
            <ProfessionalDataContactInformationForm data={data.usuarios} />
          ) : null}
        </AsyncDataWrapper>
      </Page>
    </>
  );
};

export const Route = createFileRoute(
  "/settings/profile/professional-data/edit/professional-data-contact-information",
)({
  component: EditProfessionalDataContactInformationPage,
});
